// external js: flickity.pkgd.js

// add this code
Flickity.prototype._createResizeClass = function() {
  this.element.classList.add('flickity-resize');
};

Flickity.createMethods.push('_createResizeClass');

var resize = Flickity.prototype.resize;
Flickity.prototype.resize = function() {
  this.element.classList.remove('flickity-resize');
  resize.call( this );
  this.element.classList.add('flickity-resize');
};


var testimonials = document.querySelector('#shopify-section-template--15533662503091__1647996217794e0449 .multicolumn .page-width .slider-mobile-gutter .grid');
var flkty = new Flickity( testimonials, {
  // options
  cellAlign: 'left',
  contain: true,
  pageDots: false
});

var customer_reviews1 = document.querySelector('#shopify-section-template--15546198229171__1648115377affd00b4 .multicolumn .page-width .slider-mobile-gutter .grid');
var flkty = new Flickity( customer_reviews1, {
  // options
  cellAlign: 'left',
  contain: true,
  pageDots: false
});

var customer_reviews2 = document.querySelector('#shopify-section-template--15545444696243__1648115377affd00b4 .multicolumn .page-width .slider-mobile-gutter .grid');
var flkty = new Flickity( customer_reviews2, {
  // options
  cellAlign: 'left',
  contain: true,
  pageDots: false
});

var amazing_results_cream = document.querySelector('#shopify-section-template--15546198229171__16481057138ee9cea6 .multicolumn .page-width .slider-mobile-gutter .multicolumn-list');
var flkty = new Flickity( amazing_results_cream, {
  // options
  cellAlign: 'left',
  contain: true,
  pageDots: false,
  prevNextButtons: false
});

var amazing_results_scrub = document.querySelector('#shopify-section-template--15545444696243__16481057138ee9cea6 .multicolumn .page-width .slider-mobile-gutter .multicolumn-list');
var flkty = new Flickity( amazing_results_scrub, {
  // options
  cellAlign: 'left',
  contain: true,
  pageDots: false,
  prevNextButtons: false
});

let scrollpos = window.scrollY;
const header = document.querySelector("#shopify-section-header"),
  header_height = header.offsetHeight,
  add_class_on_scroll = () => header.classList.add("scrolled"),
  remove_class_on_scroll = () => header.classList.remove("scrolled");
window.addEventListener("scroll", function () {
  (scrollpos = window.scrollY),
    scrollpos >= header_height
      ? add_class_on_scroll()
      : remove_class_on_scroll();
});
